import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiAlertCircle, FiLoader } from 'react-icons/fi';

const StatusNotification = ({ status }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status && status !== '') {
      setVisible(true);

      // Only start the 3-second auto-hide timer if the state is finished (saved or error)
      // This ensures loading screens do not disappear mid-progress
      if (status === 'saved' || status === 'error') {
        const timer = setTimeout(() => {
          setVisible(false);
        }, 3000);
        return () => clearTimeout(timer);
      }
    } else {
      setVisible(false);
    }
  }, [status]);

  if (!visible || !status) return null;

  const getStatusConfig = () => {
    switch (status) {
      case 'saving':
      case 'uploading':
        return {
          icon: <FiLoader className="animate-spin h-4 w-4 text-blue-600" />,
          borderColor: 'border-blue-100',
          bgColor: 'bg-blue-50/95 backdrop-blur-xs',
          textColor: 'text-blue-900',
          message: status === 'saving' ? 'Saving changes...' : 'Uploading file...'
        };
      case 'saved':
        return {
          icon: <FiCheckCircle className="h-4 w-4 text-emerald-600" />,
          borderColor: 'border-emerald-100',
          bgColor: 'bg-emerald-50/95 backdrop-blur-xs',
          textColor: 'text-emerald-900',
          message: 'Changes saved successfully!'
        };
      case 'error':
        return {
          icon: <FiAlertCircle className="h-4 w-4 text-rose-600" />,
          borderColor: 'border-rose-100',
          bgColor: 'bg-rose-50/95 backdrop-blur-xs',
          textColor: 'text-rose-900',
          message: 'Failed to save changes'
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <div 
      className={`
        fixed 
        bottom-4 
        right-4 
        left-4 
        sm:left-auto 
        px-4 
        py-3 
        rounded-xl 
        border 
        shadow-md 
        flex 
        items-center 
        gap-3 
        z-50 
        transition-all 
        duration-300
        ${config.borderColor} 
        ${config.bgColor} 
        ${config.textColor}
      `}
      style={{
        animation: 'statusSlideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards'
      }}
    >
      <div className="flex-shrink-0">
        {config.icon}
      </div>
      <p className="text-sm font-medium tracking-wide">
        {config.message}
      </p>
    </div>
  );
};

export default StatusNotification;